// extracted by mini-css-extract-plugin
module.exports = {"container":"Chat_container__14PP-","spinner":"Chat_spinner__33JnW","default":"Chat_default__MVqDx","emptyUsersContainer":"Chat_emptyUsersContainer__2C0qC"};